import React from 'react'
import {Link as NavLink, Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Link as RouteLink} from 'react-router-dom'
import PropTypes from 'prop-types'
import CategoryTallImage from './category-tall-image'
import Video from '../../hero/partials/video'
import CategoryTitle from './category-title'
import usePdTagManager from '../../../../../hooks/use-pd-tag-manager'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
const Card = (props) => {
    const {
        linkUrl,
        aspectRatio,
        index,
        typeId,

        // Image Settings
        desktopVideo,
        desktopVideoThumbnail,
        mobileVideo,
        mobileVideoThumbnail,
        videoAlt,
        videoDisableAutoPlay,
        videoEnableSound,

        // Video Settings
        desktopImage,
        imageAlt,
        mobileImage,

        // Title Basic Settings
        title,
        titleAlign,
        titleColor,
        titleFontFamily,
        titleTag,

        // Title Font Settings
        titleSizeLargeDesktop,
        titleSizeMobile,
        titleSizeSmallDesktop,
        titleSizeTablet
    } = props
    const appOrigin = useAppOrigin()
    const pdTagManager = usePdTagManager()
    const shouldDisplayVideo = desktopVideo || mobileVideo
    const isExternalDomain = linkUrl?.indexOf('http') !== -1
    const wrapperProps =
        linkUrl && !shouldDisplayVideo
            ? isExternalDomain
                ? {as: NavLink, href: linkUrl}
                : {as: RouteLink, to: linkUrl, display: 'block'}
            : {}
    const linkProps = linkUrl ? {display: 'block'} : {}

    return (
        <Box
            {...wrapperProps}
            {...linkProps}
            className="category-row-tall"
            gap={{base: '15px', md: '10px'}}
            display="grid"
            height="auto"
            _hover={{
                textDecoration: 'unset !important'
            }}
            onClick={() => {
                if (shouldDisplayVideo) {
                    return
                }
                pdTagManager.selectComponent({
                    componentId: typeId,
                    componentName: name,
                    titleName: title,
                    titlePosition: index,
                    linkUrl: linkUrl?.indexOf('http') !== -1 ? linkUrl : `${appOrigin}${linkUrl}`,
                    imageUrl: desktopImage || mobileImage
                })
            }}
        >
            {shouldDisplayVideo ? (
                <Video
                    desktopVideo={desktopVideo}
                    mobileVideo={mobileVideo || desktopVideo}
                    desktopVideoThumbnail={desktopVideoThumbnail}
                    mobileVideoThumbnail={mobileVideoThumbnail}
                    videoDisableAutoPlay={videoDisableAutoPlay}
                    videoEnableSound={videoEnableSound}
                    videoAlt={videoAlt}
                />
            ) : (
                <CategoryTallImage
                    desktopImage={desktopImage}
                    mobileImage={mobileImage}
                    imageAlt={imageAlt}
                    aspectRatio={aspectRatio}
                />
            )}
            <CategoryTitle
                title={title}
                index={index}
                videoUrl={mobileVideo || desktopVideo}
                typeId={typeId}
                titleColor={titleColor}
                titleTag={titleTag}
                titleSizeMobile={titleSizeMobile}
                titleSizeTablet={titleSizeTablet}
                titleSizeLargeDesktop={titleSizeLargeDesktop}
                titleFontFamily={titleFontFamily}
                titleSizeSmallDesktop={titleSizeSmallDesktop}
                titleAlign={titleAlign}
                shouldDisplayVideo={shouldDisplayVideo}
                linkUrl={linkUrl}
            />
        </Box>
    )
}

Card.propTypes = {
    // General Settings
    linkUrl: PropTypes.any,
    aspectRatio: PropTypes.any,
    index: PropTypes.number,
    typeId: PropTypes.string,

    // Video props
    desktopVideo: PropTypes.string,
    desktopVideoThumbnail: PropTypes.string,
    mobileVideo: PropTypes.string,
    mobileVideoThumbnail: PropTypes.string,
    videoAlt: PropTypes.string,
    videoDisableAutoPlay: PropTypes.bool,
    videoEnableSound: PropTypes.bool,

    // Image props
    desktopImage: PropTypes.string,
    mobileImage: PropTypes.string,
    imageAlt: PropTypes.string,

    // Title props
    title: PropTypes.string,
    titleAlign: PropTypes.string,
    titleColor: PropTypes.string,
    titleFontFamily: PropTypes.string,
    titleTag: PropTypes.string,

    // Title sizes
    titleSizeLargeDesktop: PropTypes.string,
    titleSizeSmallDesktop: PropTypes.string,
    titleSizeTablet: PropTypes.string,
    titleSizeMobile: PropTypes.string
}

export default Card
